import Component from '../core/Component'
import Scroll from '../services/Scroll'
import withMedia from '../core/withMedia'

class Sticky3 extends Component {
    constructor(element, options = {}) {
        super(element, options = {
            targetEnd: '',
            vAlign: 'top',
            offsetY: 0,
            isScrollOffsetCalculated: true,
            stickyClassname: 'is-sticky',
            ...options
        })

        this.state = null
        this.isSticky = false
        this.isEndPositionApplied = false
        this.resizeTimer = null
    }

    prepare() {
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize-x', this.handleResize)

        this.resize()
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize-x', this.handleResize)
    }

    handleScroll = () => {
        this.update()
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        clearTimeout(this.resizeTimer)
        this.clear()

        this.resizeTimer = setTimeout(() => {
            this.resizeEnd()
        }, 1000)
    }

    resizeEnd() {
        const scroll = Scroll.getScroll()

        const parentRect = this.element.parentNode.getBoundingClientRect()
        const rect = this.element.getBoundingClientRect()
        const endRect = this.options.targetEnd ? document.querySelector(this.options.targetEnd)?.getBoundingClientRect() : null

        let documentStart = scroll.y + rect.top
        let documentEnd = 9999999
        let vAlignOffset = 0

        if (endRect) {
            documentEnd = scroll.y + endRect.top + endRect.height - rect.height
        }
        if (this.options.vAlign === 'center') {
            vAlignOffset = Math.max(0,((Scroll.window.height - rect.height) / 2))
            documentStart -= vAlignOffset
            documentEnd -= vAlignOffset
        }

        this.state = {
            documentStart,
            documentEnd,
            vAlignOffset
        }

        this.element.parentNode.style.width = `${parentRect.width}px`
        this.element.parentNode.style.height = `${parentRect.height}px`
        this.element.style.width = `${rect.width}px`
        this.element.style.height = `${rect.height}px`
        this.element.style.left = `${rect.left}px`

        this.update()
    }

    clear() {
        this.element.parentNode.style.width = ''
        this.element.parentNode.style.height = ''
        this.element.style.transform = ''
        this.element.style.height = ''
        this.element.style.width = ''
        this.element.style.top = ''
        this.element.style.left = ''
        this.element.style.position = ''
        this.isSticky = false
    }

    update() {
        if (!this.state) {
            return
        }

        let shouldBeSticky = false
        const scrollY = Scroll.getScroll().y
        const scrollYOffset = (this.options.isScrollOffsetCalculated ? Scroll.getScrollOffset() : 0) + this.options.offsetY
        const isAfterStartPosition = this.state.documentStart < scrollY + scrollYOffset
        const isBeforeEndPosition = this.state.documentEnd > scrollY + scrollYOffset
        if (isAfterStartPosition && isBeforeEndPosition) {
            shouldBeSticky = true
        } else {
            shouldBeSticky = false
        }

        this.element.style.top = `${scrollYOffset + this.state.vAlignOffset}px`

        if (!isBeforeEndPosition && !this.isEndPositionApplied) {
            const y = this.state.documentEnd - this.state.documentStart
            this.element.style.transform = `translateY(${y}px)`
            this.isEndPositionApplied = true
        }

    if (isBeforeEndPosition && this.isEndPositionApplied) {
            this.element.style.transform = ``
            this.isEndPositionApplied = false
        }

        if ((shouldBeSticky && this.isSticky) || (!shouldBeSticky && !this.isSticky)) {
            return
        }

        if (shouldBeSticky) {
            this.element.style.position = `fixed`
            this.isSticky = true
            this.element.classList.add(this.options.stickyClassname)
        } else {
            this.element.style.position = ``
            this.isSticky = false
            this.element.classList.remove(this.options.stickyClassname)
        }
    }
}

export default withMedia(Sticky3)